export default (function () {
  function bindEvents() {
    document
      .querySelectorAll('.card-slider-item:not(.parsed)')
      .forEach((sliderItemElement) => {
        sliderItemElement.classList.add('parsed');

        sliderItemElement.addEventListener('click', (event) => {
          event.stopPropagation();
          let linkElement = sliderItemElement.querySelector(
            '.card-slider-item__inner__cta a',
          );
          linkElement.click();
        });
      });
  }

  function init() {
    bindEvents();
  }

  return {
    init: init,
  };
})();
